import { Facebook, Instagram, Youtube } from "lucide-react";

// TikTok icon (not available in lucide-react)
const TikTokIcon = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.84a8.16 8.16 0 0 0 4.77 1.52V6.92a4.85 4.85 0 0 1-1.84-.23Z" />
  </svg>
);

const quick = [
  { label: "About Sikaiadah", href: "#about" },
  { label: "Platform", href: "#platform" },
  { label: "Ward 3 & Communities", href: "#ward-3" },
  { label: "Supporters", href: "#supporters" },
  { label: "Latest", href: "#latest" },
];

const involved = [
  { label: "Volunteer", href: "#get-involved" },
  { label: "Host a Together We Grow with Si Event", href: "#get-involved" },
  { label: "Request a Yard Sign", href: "#get-involved" },
  { label: "Donate", href: "#donate" },
];

export const Footer = () => {
  return (
    <footer
      id="donate"
      data-testid="site-footer"
      className="relative bg-[#0E0526] text-classy pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-4">
            <img
              src="/assets/logo.png"
              alt="Together We Grow Ward 3"
              className="h-56 lg:h-72 w-auto object-contain mb-6 -ml-3"
            />
            <p className="text-classy-soft/80 text-sm leading-relaxed max-w-sm">
              A movement built on community. Sikaiadah Newton is running for
              Norfolk City Council, Ward 3 — because together, we grow.
            </p>
          </div>

          <div className="lg:col-span-2">
            <p className="text-[10px] tracking-[0.32em] uppercase text-classy-soft mb-5">
              Quick Links
            </p>
            <ul className="space-y-3">
              {quick.map((q) => (
                <li key={q.label}>
                  <a
                    href={q.href}
                    data-testid={`footer-quick-${q.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-classy-soft hover:text-classy text-sm transition-colors"
                  >
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[10px] tracking-[0.32em] uppercase text-classy-soft mb-5">
              Get Involved
            </p>
            <ul className="space-y-3">
              {involved.map((q) => (
                <li key={q.label}>
                  <a
                    href={q.href}
                    data-testid={`footer-involved-${q.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-classy-soft hover:text-classy text-sm transition-colors"
                  >
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[10px] tracking-[0.32em] uppercase text-classy-soft mb-5">
              Stay Connected
            </p>
            <div className="flex items-center gap-3 mb-6">
              <a
                href="https://www.facebook.com/TogetherWeGrow3/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-facebook"
                aria-label="Facebook"
                className="h-11 w-11 rounded-full border border-white/20 hover:border-lavender hover:bg-lavender hover:text-royal-deep flex items-center justify-center transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/p/DYS8sO2vKah/?__d=1%2F"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                aria-label="Instagram"
                className="h-11 w-11 rounded-full border border-white/20 hover:border-lavender hover:bg-lavender hover:text-royal-deep flex items-center justify-center transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.tiktok.com/@togetherwegrow_3?_r=1&_t=ZP-97Z8q1Z86wh"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-tiktok"
                aria-label="TikTok"
                className="h-11 w-11 rounded-full border border-white/20 hover:border-lavender hover:bg-lavender hover:text-royal-deep flex items-center justify-center transition-all duration-300"
              >
                <TikTokIcon size={18} />
              </a>
              <a
                href="https://www.youtube.com/@togetherwegrow_3"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-youtube"
                aria-label="YouTube"
                className="h-11 w-11 rounded-full border border-white/20 hover:border-lavender hover:bg-lavender hover:text-royal-deep flex items-center justify-center transition-all duration-300"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="divider-line mb-8"></div>

        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 text-classy-soft/70 text-xs">
          <p
            data-testid="footer-disclaimer"
            className="tracking-wide"
          >
            Site Created by Phillip Adams and Authorized by Together We Grow with Sikaiadah Newton.
          </p>
          <p className="font-serif-display italic text-lavender text-sm">
            Community Is Our Power.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
